import React, { useEffect, useRef, useState } from 'react'

//TODO: Isolate specific styles
import classes from '../../pages/Homepage/Dashboard.module.css'
import classNames from 'classnames'
import { ReactComponent as ArrowIcon } from '../../assets/icons/arrow-right.svg'
import coursePlaceholder from '../../assets/images/course-placeholder.svg'
import Carousel from '../Carousel/Carousel'
import { CourseCard } from '../Cards/GeneralCard/Card'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ourCoursesSelectors } from './ourCoursesSlice'
import CardLoader from '../loaders/CardLoader'
import { getImageURL } from '../../util/functions'
import { getOurCourses } from './ourCoursesApi'
import notification from '../Notification/notification'
import { CardTooltip } from '../Cards/GeneralCard/CardTooltip'
import TooltipWrapper from '../Tooltip/Tooltip'
import { userSelectors } from '../../redux/userSlice'
import { addCourseToCart } from '../../pages/Cart/cartApi'
import { useAuthReminderModal } from '../../hooks/useAuthReminderModal'
import {
    isItemInWishlist,
    removeFromWishlist,
    addToWishlist,
} from '../../pages/WishList/wishListApi'
import { wishListSelectors } from '../../pages/WishList/wishListSlice'

const OurCourses = () => {
    const coursesPrevButton = useRef()
    const coursesNextButton = useRef()
    const history = useHistory()

    const isFetching = useSelector(ourCoursesSelectors.isFetching)
    const courses = useSelector(ourCoursesSelectors.courses)
    const hasError = useSelector(ourCoursesSelectors.hasError)
    const isLoggedIn = useSelector(userSelectors.isLoggedIn)

    const dispatch = useDispatch()
    const [addingToCart, setAddingToCart] = useState(false)

    useEffect(() => {
        dispatch(getOurCourses())
    }, [])

    useEffect(() => {
        if (hasError) {
            notification.failure({
                title: 'Something went wrong while fetching our courses',
            })
        }
    }, [hasError])

    const addToCart = (course, free) => {
        history.push(`/app/browse/courses/${course.coursecode}`)
        // if (isLoggedIn) {
        //     notification.loading({
        //         title: 'Adding to cart',
        //     })
        // }
        // setAddingToCart(true)
        // dispatch(
        //     addCourseToCart({
        //         id: course.coursecode,
        //         course,
        //         free,
        //     })
        // )
        //     .then(() => {
        //         notification.destroy()
        //         notification.success({
        //             title: 'Success!',
        //             description: `${course.title} successfully added to cart`,
        //         })
        //         setAddingToCart(false)
        //     })
        //     .catch(() => {
        //         notification.destroy()
        //         notification.failure({
        //             title: 'Error!',
        //             description: `Something went wrong`,
        //         })
        //         setAddingToCart(false)
        //     })
    }

    return (
        <>
            <div className={classes.cardsCarousel}>
                <button
                    className={classNames(
                        classes.cardsButton,
                        classes.cardsButtonLeft
                    )}
                    ref={coursesPrevButton}
                >
                    <ArrowIcon
                        className={classNames(
                            classes.cardsButtonIcon,
                            classes.cardsButtonIconLeft
                        )}
                    />
                </button>
                <Carousel
                    prevButton={coursesPrevButton}
                    nextButton={coursesNextButton}
                    slideClassName={classes.recommendedCourseCard}
                >
                    <Courses
                        isFetching={isFetching}
                        courses={courses}
                        addToCart={addToCart}
                        addingToCart={addingToCart}
                    />
                </Carousel>
                <button
                    className={classNames(
                        classes.cardsButton,
                        classes.cardsButtonRight
                    )}
                    ref={coursesNextButton}
                >
                    <ArrowIcon className={classes.cardsButtonIcon} />
                </button>
            </div>
            <div className={classes.cardsGrid}>
                <Courses
                    isFetching={isFetching}
                    courses={courses}
                    addToCart={addToCart}
                    addingToCart={addingToCart}
                />
            </div>
        </>
    )
}

const Courses = ({ courses, isFetching, addToCart, addingToCart }) => {
    const { renderModal, conditionallyShowModal } = useAuthReminderModal()
    const dispatch = useDispatch()
    const wishlistCourses = useSelector(wishListSelectors.courses)

    if (isFetching) {
        return [...Array(6)].map((_, idx) => <CardLoader key={idx} />)
    }

    const handleAddToWishlist = course => event => {
        event.preventDefault()
        conditionallyShowModal(() => {
            if (isItemInWishlist(wishlistCourses, course.coursecode)) {
                dispatch(
                    removeFromWishlist({
                        type: 'course',
                        itemId: course.coursecode,
                    })
                )
            } else {
                dispatch(
                    addToWishlist({
                        type: 'course',
                        itemId: course.coursecode,
                    })
                )
            }
        })()
    }

    return courses.map(course => (
        <TooltipWrapper
            key={course.coursecode}
            tooltip={
                <CardTooltip
                    {...course}
                    students={course.enrolled}
                    addToCart={free => addToCart(course, free)}
                    addingToCart={addingToCart}
                    addToCartCustomText="LEARN MORE"
                    addToWishlist={handleAddToWishlist(course)}
                    itemInWishlist={isItemInWishlist(
                        wishlistCourses,
                        course.coursecode
                    )}
                />
            }
        >
            <CourseCard
                showStudentCount={String(course.showstudentcount) === '1'}
                premium={String(course.freeonsubscription) === '0'}
                attendees={course.enrolled}
                coursecode={course.coursecode}
                title={course.title}
                category={course.catName}
                price={course.price}
                url={
                    course.thumbnail
                        ? getImageURL(course.thumbnail)
                        : coursePlaceholder
                }
            />
        </TooltipWrapper>
    ))
}

export default OurCourses
